(function () {
  'use strict';
  function allowed() {
    return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed());
  }
  function emit(name, context) {
    if (!allowed()) return;
    var data = {event: name, enquiry_context: context || document.title};
    if (window.Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(name, {enquiry_context: data.enquiry_context});
    }
    document.dispatchEvent(new CustomEvent('ana:lead-event', {detail: data}));
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    if (/^https:\/\/(wa\.me|api\.whatsapp\.com)\//.test(link.href)) {
      var panel = link.closest('[data-ana-context]');
      emit('ana_whatsapp_click', panel && panel.dataset.anaContext);
    }
  });
  document.addEventListener('submit', function (event) {
    if (event.target.id !== 'ana-native-quote-form') return;
    try {sessionStorage.setItem('ana_pending_quote', String(Date.now()));} catch (error) {}
  });
  function confirmed() {
    if (!document.querySelector('[data-ana-quote-success]')) return;
    var pending;
    try {pending = Number(sessionStorage.getItem('ana_pending_quote'));} catch (error) {return;}
    if (!pending || Date.now() - pending > 1800000 || !allowed()) return;
    emit('ana_quote_submitted');
    try {sessionStorage.removeItem('ana_pending_quote');} catch (error) {}
  }
  if (window.Shopify && typeof Shopify.loadFeatures === 'function' && !Shopify.customerPrivacy) {
    Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
      if (!error) confirmed();
    });
  }
  confirmed();
  document.addEventListener('visitorConsentCollected', confirmed);
})();
